import { Box, Flex, Text } from '@skin-seoul/design-system';

import { useProductCard } from '../ProductCardContext';

import React from 'react';

import EmptyStar from '../assets/EmptyStar';
import FilledStar from '../assets/FilledStar';
import { getStarFillWidth } from '@skin-seoul/service';

const ProductCardInfoRating = () => {
  const { rating = 0, reviewCount = 0, theme = 'light', showRating = true } = useProductCard();

  const renderStars = (rating: number) => {
    const stars: JSX.Element[] = [];
    for (let i = 0; i < 5; i++) {
      const currentRating = rating ?? 0;
      const fillWidth = getStarFillWidth(currentRating, i);
      stars.push(
        <Flex key={i} position="relative" width="14px" height="14px">
          <EmptyStar key={i} />
          <Flex position="absolute" width={fillWidth} height="14px" overflow="hidden">
            <FilledStar />
          </Flex>
        </Flex>,
      );
    }
    return stars;
  };

  if (!showRating) {
    return null;
  }

  if (rating > 0) {
    return (
      <Box display="flex" alignItems="center" gap={2}>
        <Text textStyle="paragraph.small" color={theme === 'dark' ? 'neutral.200' : 'neutral.400'}>
          {rating.toFixed(1)}
        </Text>
        <Box display="flex" gap={1}>
          {renderStars(rating)}
        </Box>
        <Text textStyle="paragraph.small" color={theme === 'dark' ? 'neutral.200' : 'neutral.400'}>
          ({reviewCount.toFixed(0)})
        </Text>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap="4px">
      <Text textStyle="paragraph.small" color={theme === 'dark' ? 'neutral.200' : 'neutral.400'}>
        &nbsp;
      </Text>
    </Box>
  );
};

export default ProductCardInfoRating;
